import { PaletteOptions } from "@mui/material/styles";

export const palette: PaletteOptions = {
  primary: { main: "#1E1963" },
  secondary: { main: "#CA8D1B", contrastText: "#ffffff" },
  profitColor: {
    main: "#16a34a",
    light: "#3db96b",
    dark: "#0a8136",
    contrastText: "#fff",
  },
  lossColor: {
    main: "#f44336",
    light: "#e57373",
    dark: "#d32f2f",
    contrastText: "#fff",
  },
};
